"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STSClient = exports.AssumeRoleCommand = void 0;
const sts_1 = require("@aws-sdk/nested-clients/sts");
Object.defineProperty(exports, "AssumeRoleCommand", { enumerable: true, get: function () { return sts_1.AssumeRoleCommand; } });
Object.defineProperty(exports, "STSClient", { enumerable: true, get: function () { return sts_1.STSClient; } });
